import Backbone from 'backbone';
import ParseService from '~/services/parseService';
import Model from '~/models/parseModel';
import Collection from '~/collections/parseCollection';
import toastr from 'toastr';

var localizationService;
export default function() {

	var LocalizationModel = Model.extend({
		className: "Localization",
		defaults: {}
	});

	var LocalizationCollection = Collection.extend({
		model: LocalizationModel
	});

	var LocalizationService = ParseService.extend({
		sortBy: 'createdAt',
		model: LocalizationModel,
		collection: LocalizationCollection,
		getLanguages: function() {
			var query = new Parse.Query('Localization');
			query.select('name');
			return query.find();
		},

		getLanguage: function(id) {
			var query = new Parse.Query('Localization');
			query.equalTo('objectId', id);
			query.select('name');
			query.select('abbreviation');
			return query.first();
		},

		getLanguageCatLang: function(id){
			var query = new Parse.Query('Localization');
			query.equalTo('objectId', id);
			query.select('catlang');
			return query.first();
		},

		getLanguageStaticLang: function(id){
			var query = new Parse.Query('Localization');
			query.equalTo('objectId', id);
			query.select('staticlang');
			return query.first();
		},

		updateLanguageCatLang:function(id, catlang){
			var query = new Parse.Query('Localization');
			query.equalTo("objectId", id);
			query.first({
				success: function(object) {
					object.set("catlang", catlang);
					object.save();
					toastr.success("Cambios a la traduccion guardados", "Operación realizada");
				},
				error: function(error) {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
					}
				}
			});
		},

		updateLanguageStaticLang:function(id, staticlang){
			var query = new Parse.Query('Localization');
			query.equalTo("objectId", id);
			query.first({
				success: function(object) {
					object.set("staticlang", staticlang);
					object.save();
					toastr.success("Cambios al idioma guardados", "Operación realizada");
				},
				error: function(error) {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
					}
				}
			});
		},

		createNewLanguage: function(name, abbr, done){
			var Localization = Parse.Object.extend("Localization");
			var language = new Localization();
			var staticlang = {};
			for(var i=0; i < window.mobilelangkeys.length; i++){
				staticlang[window.mobilelangkeys[i]] = "";
			}
			language.set("name",name);
			language.set("abbreviation",abbr);
			language.set("staticlang", JSON.stringify(staticlang));
			language.set("catlang","{}");
			language.save(null, {
				success: function(newlanguage) {
					done(newlanguage);
				},
				error: function(newlanguage, error) {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
						default:
							toastr.error(arrlang[lang]['NewLanguageError'],'Error');
						break;
					}
				}
			});
		},

		editLanguage: function(id, name, abbr, done){
			var query = new Parse.Query('Localization');
			query.equalTo("objectId", id);
			query.first({
				success: function(object) {
					object.set("name",name);
					object.set("abbreviation",abbr);
					object.save(null, {
						success: function(newlanguage) {
							done(newlanguage);
						},
						error: function(newlanguage, error) {
							console.log(error);
							switch(error.code){
								case 100:
									toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
								break;
								default:
									toastr.error(arrlang[lang]['EditLanguageError'],'Error');
								break;
							}
						}
					});
				},
				error: function(error) {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
					}
				}
			});
		},

		deleteLanguage: function(id, done){
			var query = new Parse.Query('Localization');
			query.get(id, {
				success: function(yourObj) {
					yourObj.destroy({
						success: function(oldLang) {
							done(oldLang);
						},
						error: function(oldLang, error) {
							console.log(error);
							switch(error.code){
								case 100:
									toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
								break;
								default:
									toastr.error(arrlang[lang]['DelLanguageError'],'Error');
								break;
							}
						}
					});
				},
				error: function(object, error) {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
						default:
							toastr.error(arrlang[lang]['DelLanguageError'],'Error');
						break;
					}
				}
			});
		}
	});

	return localizationService || (localizationService = new LocalizationService());
};
